// Updated: Full AI Platform Postman Collection with all endpoints
export const postmanCollection = {
  "info": {
    "_postman_id": "98e91119-100e-4b94-90dd-c05cee70246d",
    "name": "AI Platform API",
    "description": "Postman Collection for the centralized AI Platform serving translation, NLP, and LLM features to client applications.\n\n## Variables\n- `BASE_URL` – e.g. `https://ai.idealcorp.in` or `http://localhost:3000`\n- `API_KEY`  – Client application API key (starts with `ai_`)\n- `APP_ID`   – MongoDB ObjectId of an application (used for admin CRUD routes)",
    "schema": "https://schema.getpostman.com/json/collection/v2.1.0/collection.json"
  },
  "item": [
    {
      "name": "System",
      "description": "Platform-level health and availability checks.",
      "item": [
        {
          "name": "Health Check",
          "request": {
            "method": "GET",
            "header": [],
            "url": {
              "raw": "{{BASE_URL}}/health",
              "host": ["{{BASE_URL}}"],
              "path": ["health"]
            },
            "description": "Verifies that the API gateway server is active and running. No authentication required."
          },
          "response": []
        },
        {
          "name": "Swagger UI Documentation",
          "request": {
            "method": "GET",
            "header": [],
            "url": {
              "raw": "{{BASE_URL}}/docs",
              "host": ["{{BASE_URL}}"],
              "path": ["docs"]
            },
            "description": "Opens the interactive Swagger UI documentation page in browser. No authentication required."
          },
          "response": []
        },
        {
          "name": "Swagger JSON Specification",
          "request": {
            "method": "GET",
            "header": [],
            "url": {
              "raw": "{{BASE_URL}}/swagger.json",
              "host": ["{{BASE_URL}}"],
              "path": ["swagger.json"]
            },
            "description": "Returns the raw OpenAPI / Swagger 2.0 specification JSON schema for the API Gateway."
          },
          "response": []
        }
      ]
    },
    {
      "name": "AI Models Registry",
      "description": "Endpoints to discover and inspect available downstream LLM models (Ollama, NLLB, etc.).",
      "item": [
        {
          "name": "List Available Models (REST API)",
          "request": {
            "method": "GET",
            "header": [],
            "url": {
              "raw": "{{BASE_URL}}/api/models",
              "host": ["{{BASE_URL}}"],
              "path": ["api", "models"]
            },
            "description": "Returns a list of all currently available Ollama LLM models on the server, default model configuration, host server URL, and parameter specs."
          },
          "response": []
        },
        {
          "name": "Available Models Web Dashboard",
          "request": {
            "method": "GET",
            "header": [],
            "url": {
              "raw": "{{BASE_URL}}/models",
              "host": ["{{BASE_URL}}"],
              "path": ["models"]
            },
            "description": "Serves the interactive web dashboard (HTML+CSS+JS) for exploring available AI models on the server."
          },
          "response": []
        },
        {
          "name": "Available Models JSON Endpoint",
          "request": {
            "method": "GET",
            "header": [],
            "url": {
              "raw": "{{BASE_URL}}/models/json",
              "host": ["{{BASE_URL}}"],
              "path": ["models", "json"]
            },
            "description": "Public REST JSON endpoint returning available AI models list and server host details."
          },
          "response": []
        }
      ]
    },
    {
      "name": "AI Services",
      "description": "Customer-facing AI feature endpoints. All routes require the `X-API-KEY` header.",
      "item": [
        {
          "name": "Translation API",

          "request": {
            "method": "POST",
            "header": [
              { "key": "X-API-KEY",     "value": "{{API_KEY}}", "type": "text" },
              { "key": "Content-Type",  "value": "application/json", "type": "text" }
            ],
            "body": {
              "mode": "raw",
              "raw": "{\n  \"text\": \"Your order has been delivered successfully.\",\n  \"from\": \"en\",\n  \"to\": \"ta\"\n}",
              "options": { "raw": { "language": "json" } }
            },
            "url": {
              "raw": "{{BASE_URL}}/api/translate",
              "host": ["{{BASE_URL}}"],
              "path": ["api", "translate"]
            },
            "description": "Translates text between supported languages: English (en), Tamil (ta), Telugu (te), Hindi (hi)."
          },
          "response": []
        },
        {
          "name": "Smart Reply Suggestion API",
          "request": {
            "method": "POST",
            "header": [
              { "key": "X-API-KEY",    "value": "{{API_KEY}}", "type": "text" },
              { "key": "Content-Type", "value": "application/json", "type": "text" }
            ],
            "body": {
              "mode": "raw",
              "raw": "{\n  \"message\": \"Can you send today's report?\"\n}",
              "options": { "raw": { "language": "json" } }
            },
            "url": {
              "raw": "{{BASE_URL}}/api/replies",
              "host": ["{{BASE_URL}}"],
              "path": ["api", "replies"]
            },
            "description": "Generates 3 contextually appropriate replies to an input message."
          },
          "response": []
        },
        {
          "name": "Sentiment Analysis API",
          "request": {
            "method": "POST",
            "header": [
              { "key": "X-API-KEY",    "value": "{{API_KEY}}", "type": "text" },
              { "key": "Content-Type", "value": "application/json", "type": "text" }
            ],
            "body": {
              "mode": "raw",
              "raw": "{\n  \"text\": \"I really love using this messaging platform!\"\n}",
              "options": { "raw": { "language": "json" } }
            },
            "url": {
              "raw": "{{BASE_URL}}/api/sentiment",
              "host": ["{{BASE_URL}}"],
              "path": ["api", "sentiment"]
            },
            "description": "Analyzes the sentiment polarity (positive, negative, neutral) of a given text."
          },
          "response": []
        },
        {
          "name": "Tag Extraction API",
          "request": {
            "method": "POST",
            "header": [
              { "key": "X-API-KEY",    "value": "{{API_KEY}}", "type": "text" },
              { "key": "Content-Type", "value": "application/json", "type": "text" }
            ],
            "body": {
              "mode": "raw",
              "raw": "{\n  \"text\": \"How to deploy docker container with nginx proxy, ssl configuration, and load balancer setup.\"\n}",
              "options": { "raw": { "language": "json" } }
            },
            "url": {
              "raw": "{{BASE_URL}}/api/tags",
              "host": ["{{BASE_URL}}"],
              "path": ["api", "tags"]
            },
            "description": "Extracts relevant keywords and tags from a text block."
          },
          "response": []
        },
        {
          "name": "Language Detection API",
          "request": {
            "method": "POST",
            "header": [
              { "key": "X-API-KEY",    "value": "{{API_KEY}}", "type": "text" },
              { "key": "Content-Type", "value": "application/json", "type": "text" }
            ],
            "body": {
              "mode": "raw",
              "raw": "{\n  \"text\": \"வணக்கம், எப்படி இருக்கிறீர்கள்?\"\n}",
              "options": { "raw": { "language": "json" } }
            },
            "url": {
              "raw": "{{BASE_URL}}/api/language-detect",
              "host": ["{{BASE_URL}}"],
              "path": ["api", "language-detect"]
            },
            "description": "Identifies the language code (e.g. en, ta, hi, te) of the input text."
          },
          "response": []
        },
        {
          "name": "Text Classification API",
          "request": {
            "method": "POST",
            "header": [
              { "key": "X-API-KEY",    "value": "{{API_KEY}}", "type": "text" },
              { "key": "Content-Type", "value": "application/json", "type": "text" }
            ],
            "body": {
              "mode": "raw",
              "raw": "{\n  \"text\": \"The database connection crashed and the API server is down since 10 mins.\"\n}",
              "options": { "raw": { "language": "json" } }
            },
            "url": {
              "raw": "{{BASE_URL}}/api/classify",
              "host": ["{{BASE_URL}}"],
              "path": ["api", "classify"]
            },
            "description": "Categorizes text into: technical_issue, sales_inquiry, general_feedback, or other — with a priority score."
          },
          "response": []
        },
        {
          "name": "Text Summarization API",
          "request": {
            "method": "POST",
            "header": [
              { "key": "X-API-KEY",    "value": "{{API_KEY}}", "type": "text" },
              { "key": "Content-Type", "value": "application/json", "type": "text" }
            ],
            "body": {
              "mode": "raw",
              "raw": "{\n  \"text\": \"Node.js is an open-source, cross-platform JavaScript runtime environment that executes JavaScript code outside a web browser. Node.js lets developers use JavaScript to write command line tools and for server-side scripting.\"\n}",
              "options": { "raw": { "language": "json" } }
            },
            "url": {
              "raw": "{{BASE_URL}}/api/summarize",
              "host": ["{{BASE_URL}}"],
              "path": ["api", "summarize"]
            },
            "description": "Generates a concise summary of a large text block."
          },
          "response": []
        },
        {
          "name": "Content Moderation API",
          "request": {
            "method": "POST",
            "header": [
              { "key": "X-API-KEY",    "value": "{{API_KEY}}", "type": "text" },
              { "key": "Content-Type", "value": "application/json", "type": "text" }
            ],
            "body": {
              "mode": "raw",
              "raw": "{\n  \"text\": \"This is a clean and polite conversation.\"\n}",
              "options": { "raw": { "language": "json" } }
            },
            "url": {
              "raw": "{{BASE_URL}}/api/moderate",
              "host": ["{{BASE_URL}}"],
              "path": ["api", "moderate"]
            },
            "description": "Checks whether a text is safe or contains inappropriate content. Returns a safe/unsafe flag with reasoning."
          },
          "response": []
        },
        {
          "name": "Content Censor API",
          "request": {
            "method": "POST",
            "header": [
              { "key": "X-API-KEY",    "value": "{{API_KEY}}", "type": "text" },
              { "key": "Content-Type", "value": "application/json", "type": "text" }
            ],
            "body": {
              "mode": "raw",
              "raw": "{\n  \"text\": \"This damn product is absolute garbage and the support team are idiots.\"\n}",
              "options": { "raw": { "language": "json" } }
            },
            "url": {
              "raw": "{{BASE_URL}}/api/censor",
              "host": ["{{BASE_URL}}"],
              "path": ["api", "censor"]
            },
            "description": "Automatically censors or replaces inappropriate words/phrases in the input text. Returns a cleaned version of the text."
          },
          "response": []
        },
        {
          "name": "Auto Suggest API",
          "request": {
            "method": "POST",
            "header": [
              { "key": "X-API-KEY",    "value": "{{API_KEY}}", "type": "text" },
              { "key": "Content-Type", "value": "application/json", "type": "text" }
            ],
            "body": {
              "mode": "raw",
              "raw": "{\n  \"text\": \"how to build docker\"\n}",
              "options": { "raw": { "language": "json" } }
            },
            "url": {
              "raw": "{{BASE_URL}}/api/suggestions",
              "host": ["{{BASE_URL}}"],
              "path": ["api", "suggestions"]
            },
            "description": "Generates autocomplete completions or phrase suggestions for a partial text query."
          },
          "response": []
        },
        {
          "name": "Text Polish API",
          "request": {
            "method": "POST",
            "header": [
              { "key": "X-API-KEY",    "value": "{{API_KEY}}", "type": "text" },
              { "key": "Content-Type", "value": "application/json", "type": "text" }
            ],
            "body": {
              "mode": "raw",
              "raw": "{\n  \"text\": \"i wnt to know abut the delivry status of my ordr placed yestrday\"\n}",
              "options": { "raw": { "language": "json" } }
            },
            "url": {
              "raw": "{{BASE_URL}}/api/polish",
              "host": ["{{BASE_URL}}"],
              "path": ["api", "polish"]
            },
            "description": "Corrects grammar, fixes spelling, and improves the phrasing of a given text while preserving its original meaning."
          },
          "response": []
        },
        {
          "name": "Parse Reminder API",
          "request": {
            "method": "POST",
            "header": [
              { "key": "X-API-KEY",    "value": "{{API_KEY}}", "type": "text" },
              { "key": "Content-Type", "value": "application/json", "type": "text" }
            ],
            "body": {
              "mode": "raw",
              "raw": "{\n  \"text\": \"Remind me to submit the monthly report every Friday at 4pm\"\n}",
              "options": { "raw": { "language": "json" } }
            },
            "url": {
              "raw": "{{BASE_URL}}/api/parse-reminder",
              "host": ["{{BASE_URL}}"],
              "path": ["api", "parse-reminder"]
            },
            "description": "Parses a natural language reminder string and extracts structured fields: title, datetime, recurrence, and priority."
          },
          "response": []
        },
        {
          "name": "Chatbot API",
          "request": {
            "method": "POST",
            "header": [
              { "key": "X-API-KEY",    "value": "{{API_KEY}}", "type": "text" },
              { "key": "Content-Type", "value": "application/json", "type": "text" }
            ],
            "body": {
              "mode": "raw",
              "raw": "{\n  \"threadId\": \"test_thread_123\",\n  \"message\": \"Hello, what features do you support?\"\n}",
              "options": { "raw": { "language": "json" } }
            },
            "url": {
              "raw": "{{BASE_URL}}/api/chatbot",
              "host": ["{{BASE_URL}}"],
              "path": ["api", "chatbot"]
            },
            "description": "Interactive conversational chatbot agent supporting thread persistence."
          },
          "response": []
        },
        {
          "name": "Embeddings API",
          "request": {
            "method": "POST",
            "header": [
              { "key": "X-API-KEY",    "value": "{{API_KEY}}", "type": "text" },
              { "key": "Content-Type", "value": "application/json", "type": "text" }
            ],
            "body": {
              "mode": "raw",
              "raw": "{\n  \"text\": \"This is a test of sentence embeddings.\"\n}",
              "options": { "raw": { "language": "json" } }
            },
            "url": {
              "raw": "{{BASE_URL}}/api/embeddings",
              "host": ["{{BASE_URL}}"],
              "path": ["api", "embeddings"]
            },
            "description": "Generates high-dimensional embedding vectors for the input text using sentence-transformers."
          },
          "response": []
        },
        {
          "name": "RAG Query API",
          "request": {
            "method": "POST",
            "header": [
              { "key": "X-API-KEY",    "value": "{{API_KEY}}", "type": "text" },
              { "key": "Content-Type", "value": "application/json", "type": "text" }
            ],
            "body": {
              "mode": "raw",
              "raw": "{\n  \"prompt\": \"tell me about antigravity developer agent features\",\n  \"limit\": 3\n}",
              "options": { "raw": { "language": "json" } }
            },
            "url": {
              "raw": "{{BASE_URL}}/api/rag/query",
              "host": ["{{BASE_URL}}"],
              "path": ["api", "rag", "query"]
            },
            "description": "Queries the RAG database to generate a response contextualized by similarity matches."
          },
          "response": []
        },
        {
          "name": "RAG Ingest API",
          "request": {
            "method": "POST",
            "header": [
              { "key": "X-API-KEY",    "value": "{{API_KEY}}", "type": "text" },
              { "key": "Content-Type", "value": "application/json", "type": "text" }
            ],
            "body": {
              "mode": "raw",
              "raw": "{\n  \"title\": \"Project Antigravity Overview\",\n  \"content\": \"Project Antigravity is a codebase intelligence agent developed by Google DeepMind.\"\n}",
              "options": { "raw": { "language": "json" } }
            },
            "url": {
              "raw": "{{BASE_URL}}/api/rag/ingest",
              "host": ["{{BASE_URL}}"],
              "path": ["api", "rag", "ingest"]
            },
            "description": "Ingests documents into the vector store database for Retrieval Augmented Generation."
          },
          "response": []
        },
        {
          "name": "FAQ Query API",
          "request": {
            "method": "POST",
            "header": [
              { "key": "X-API-KEY",    "value": "{{API_KEY}}", "type": "text" },
              { "key": "Content-Type", "value": "application/json", "type": "text" }
            ],
            "body": {
              "mode": "raw",
              "raw": "{\n  \"query\": \"where can i change my account login pass key?\",\n  \"threshold\": 0.5\n}",
              "options": { "raw": { "language": "json" } }
            },
            "url": {
              "raw": "{{BASE_URL}}/api/faq/query",
              "host": ["{{BASE_URL}}"],
              "path": ["api", "faq", "query"]
            },
            "description": "Retrieves answers to query text by comparing it semantically against stored FAQ lists."
          },
          "response": []
        },
        {
          "name": "FAQ Ingest API",
          "request": {
            "method": "POST",
            "header": [
              { "key": "X-API-KEY",    "value": "{{API_KEY}}", "type": "text" },
              { "key": "Content-Type", "value": "application/json", "type": "text" }
            ],
            "body": {
              "mode": "raw",
              "raw": "{\n  \"question\": \"How do I reset my account password?\",\n  \"answer\": \"You can reset your password by going to the Settings page and clicking on Security Options.\"\n}",
              "options": { "raw": { "language": "json" } }
            },
            "url": {
              "raw": "{{BASE_URL}}/api/faq/ingest",
              "host": ["{{BASE_URL}}"],
              "path": ["api", "faq", "ingest"]
            },
            "description": "Stores a question-answer pair in the vector database for Q&A matching."
          },
          "response": []
        },
        {
          "name": "Image Caption API",
          "request": {
            "method": "POST",
            "header": [{ "key": "X-API-KEY", "value": "{{API_KEY}}", "type": "text" }],
            "body": {
              "mode": "formdata",
              "formdata": [{ "key": "file", "type": "file", "src": [] }]
            },
            "url": {
              "raw": "{{BASE_URL}}/api/image-caption",
              "host": ["{{BASE_URL}}"],
              "path": ["api", "image-caption"]
            },
            "description": "Generates a textual description/caption for the uploaded image file."
          },
          "response": []
        },
        {
          "name": "OCR API",
          "request": {
            "method": "POST",
            "header": [{ "key": "X-API-KEY", "value": "{{API_KEY}}", "type": "text" }],
            "body": {
              "mode": "formdata",
              "formdata": [{ "key": "file", "type": "file", "src": [] }]
            },
            "url": {
              "raw": "{{BASE_URL}}/api/ocr",
              "host": ["{{BASE_URL}}"],
              "path": ["api", "ocr"]
            },
            "description": "Performs Optical Character Recognition on an uploaded image file."
          },
          "response": []
        },
        {
          "name": "Speech to Text (STT) API",
          "request": {
            "method": "POST",
            "header": [{ "key": "X-API-KEY", "value": "{{API_KEY}}", "type": "text" }],
            "body": {
              "mode": "formdata",
              "formdata": [{ "key": "file", "type": "file", "src": [] }]
            },
            "url": {
              "raw": "{{BASE_URL}}/api/stt",
              "host": ["{{BASE_URL}}"],
              "path": ["api", "stt"]
            },
            "description": "Transcribes an uploaded audio file (e.g. WAV/MP3) into text."
          },
          "response": []
        },
        {
          "name": "Text to Speech (TTS) API",
          "request": {
            "method": "POST",
            "header": [
              { "key": "X-API-KEY",    "value": "{{API_KEY}}", "type": "text" },
              { "key": "Content-Type", "value": "application/json", "type": "text" }
            ],
            "body": {
              "mode": "raw",
              "raw": "{\n  \"text\": \"Hello from the central speech libraries.\",\n  \"lang\": \"en\"\n}",
              "options": { "raw": { "language": "json" } }
            },
            "url": {
              "raw": "{{BASE_URL}}/api/tts",
              "host": ["{{BASE_URL}}"],
              "path": ["api", "tts"]
            },
            "description": "Synthesizes an audio stream from the input text. Returns an audio/mpeg file."
          },
          "response": []
        },
        {
          "name": "Recommendation API",
          "request": {
            "method": "POST",
            "header": [
              { "key": "X-API-KEY",    "value": "{{API_KEY}}", "type": "text" },
              { "key": "Content-Type", "value": "application/json", "type": "text" }
            ],
            "body": {
              "mode": "raw",
              "raw": "{\n  \"text\": \"tell me about the central NLP and speech libraries framework\",\n  \"limit\": 5\n}",
              "options": { "raw": { "language": "json" } }
            },
            "url": {
              "raw": "{{BASE_URL}}/api/recommendation",
              "host": ["{{BASE_URL}}"],
              "path": ["api", "recommendation"]
            },
            "description": "Generates custom recommendations and tags based on semantic content analysis."
          },
          "response": []
        },
        {
          "name": "Image Moderation API",
          "request": {
            "method": "POST",
            "header": [{ "key": "X-API-KEY", "value": "{{API_KEY}}", "type": "text" }],
            "body": {
              "mode": "formdata",
              "formdata": [{ "key": "file", "type": "file", "src": [] }]
            },
            "url": {
              "raw": "{{BASE_URL}}/api/moderate-image",
              "host": ["{{BASE_URL}}"],
              "path": ["api", "moderate-image"]
            },
            "description": "Analyzes an uploaded image file for inappropriate or NSFW content."
          },
          "response": []
        }
      ]
    },
    {
      "name": "Admin – Applications",
      "description": "CRUD operations for managing registered client applications. No API key required — admin access only.",
      "item": [
        {
          "name": "Register New Application",
          "request": {
            "method": "POST",
            "header": [{ "key": "Content-Type", "value": "application/json", "type": "text" }],
            "body": {
              "mode": "raw",
              "raw": "{\n  \"name\": \"iChat\",\n  \"dailyLimit\": 100000,\n  \"allowedDomains\": [\"https://ichat.com\"],\n  \"enabledFeatures\": [\"translate\",\"replies\",\"sentiment\",\"chatbot\",\"embeddings\",\"rag\",\"stt\",\"tts\",\"ocr\",\"image-caption\",\"recommendation\",\"moderate-image\"]\n}",
              "options": { "raw": { "language": "json" } }
            },
            "url": {
              "raw": "{{BASE_URL}}/admin/applications",
              "host": ["{{BASE_URL}}"],
              "path": ["admin", "applications"]
            },
            "description": "Registers a new client application. Automatically generates a secure API key (starts with ai_). Returns the full application object including the generated apiKey."
          },
          "response": []
        },
        {
          "name": "List Applications (with Pagination & Filters)",
          "request": {
            "method": "GET",
            "header": [],
            "url": {
              "raw": "{{BASE_URL}}/admin/applications?page=1&limit=20&search=&status=&feature=",
              "host": ["{{BASE_URL}}"],
              "path": ["admin", "applications"],
              "query": [
                { "key": "page", "value": "1", "description": "Page number (1-indexed). Default: 1" },
                { "key": "limit", "value": "20", "description": "Items per page (max 100). Default: 20" },
                { "key": "search", "value": "", "description": "Partial, case-insensitive search on application name." },
                { "key": "status", "value": "", "description": "Filter by status: active | inactive" },
                { "key": "feature", "value": "", "description": "Filter applications with a specific feature enabled." }
              ]
            },
            "description": "Returns a paginated list of all registered applications with filters for search, status, and feature."
          },
          "response": []
        },
        {
          "name": "Get Application by ID",
          "request": {
            "method": "GET",
            "header": [],
            "url": {
              "raw": "{{BASE_URL}}/admin/applications/{{APP_ID}}",
              "host": ["{{BASE_URL}}"],
              "path": ["admin", "applications", "{{APP_ID}}"]
            },
            "description": "Fetches the full details of a single application by its MongoDB _id. Returns 404 if not found."
          },
          "response": []
        },
        {
          "name": "Update Application",
          "request": {
            "method": "PUT",
            "header": [{ "key": "Content-Type", "value": "application/json", "type": "text" }],
            "body": {
              "mode": "raw",
              "raw": "{\n  \"dailyLimit\": 200000,\n  \"status\": \"active\",\n  \"enabledFeatures\": [\"translate\",\"replies\",\"chatbot\",\"stt\",\"tts\"],\n  \"allowedDomains\": [\"https://ichat.com\",\"https://app.ichat.com\"]\n}",
              "options": { "raw": { "language": "json" } }
            },
            "url": {
              "raw": "{{BASE_URL}}/admin/applications/{{APP_ID}}",
              "host": ["{{BASE_URL}}"],
              "path": ["admin", "applications", "{{APP_ID}}"]
            },
            "description": "Partially updates an existing application. Accepted fields: name, dailyLimit, allowedDomains, enabledFeatures, status. The apiKey cannot be changed."
          },
          "response": []
        },
        {
          "name": "Delete Application",
          "request": {
            "method": "DELETE",
            "header": [],
            "url": {
              "raw": "{{BASE_URL}}/admin/applications/{{APP_ID}}",
              "host": ["{{BASE_URL}}"],
              "path": ["admin", "applications", "{{APP_ID}}"]
            },
            "description": "Permanently deletes a registered application. This action is irreversible — the API key immediately stops working."
          },
          "response": []
        }
      ]
    },
    {
      "name": "Admin – Prompt Templates",
      "description": "Manage LLM prompt templates for individual AI features.",
      "item": [
        {
          "name": "Upsert Prompt Template",
          "request": {
            "method": "POST",
            "header": [{ "key": "Content-Type", "value": "application/json", "type": "text" }],
            "body": {
              "mode": "raw",
              "raw": "{\n  \"feature\": \"replies\",\n  \"template\": \"Generate replies for the following message: \\\"{message}\\\"\",\n  \"systemPrompt\": \"You are a smart reply assistant. Output ONLY a valid JSON array.\",\n  \"isActive\": true\n}",
              "options": { "raw": { "language": "json" } }
            },
            "url": {
              "raw": "{{BASE_URL}}/admin/templates",
              "host": ["{{BASE_URL}}"],
              "path": ["admin", "templates"]
            },
            "description": "Creates or updates the prompt template for the given feature (upsert). Valid features: replies, summarize, suggestions, moderate, classify."
          },
          "response": []
        },
        {
          "name": "List All Prompt Templates",
          "request": {
            "method": "GET",
            "header": [],
            "url": {
              "raw": "{{BASE_URL}}/admin/templates",
              "host": ["{{BASE_URL}}"],
              "path": ["admin", "templates"]
            },
            "description": "Returns all saved prompt templates sorted alphabetically by feature name."
          },
          "response": []
        }
      ]
    },
    {
      "name": "Admin – Monitoring",
      "description": "System health, model status, and dashboard statistics.",
      "item": [
        {
          "name": "Model & Server Status",
          "request": {
            "method": "GET",
            "header": [],
            "url": {
              "raw": "{{BASE_URL}}/admin/models",
              "host": ["{{BASE_URL}}"],
              "path": ["admin", "models"]
            },
            "description": "Returns real-time status of downstream AI services and server resource usage including CPU, memory, and model availability (ollama, nllb)."
          },
          "response": []
        },
        {
          "name": "Dashboard Statistics",
          "request": {
            "method": "GET",
            "header": [],
            "url": {
              "raw": "{{BASE_URL}}/admin/stats",
              "host": ["{{BASE_URL}}"],
              "path": ["admin", "stats"]
            },
            "description": "Returns aggregated usage statistics: totalRequests, requestsByFeature, requestsByApplication, cacheHitRate, avgResponseTimeMs, modelHealth."
          },
          "response": []
        }
      ]
    }
  ],
  "variable": [
    {
      "key": "BASE_URL",
      "value": "https://ai.idealcorp.in",
      "type": "string",
      "description": "Base URL of the AI Platform. Switch to http://localhost:3000 for local development."
    },
    {
      "key": "API_KEY",
      "value": "ai_your_key_here",
      "type": "string",
      "description": "Client application API key. Obtain this from the Register Application endpoint."
    },
    {
      "key": "APP_ID",
      "value": "",
      "type": "string",
      "description": "MongoDB ObjectId of a registered application. Used in GET/PUT/DELETE /admin/applications/:id routes."
    }
  ]
};
